var ChartingFlowParam;
(function (ChartingFlowParam) {
    ChartingFlowParam["ORDER_ID"] = "orderID";
})(ChartingFlowParam || (ChartingFlowParam = {}));

export { ChartingFlowParam };
